/*
  Claire Powell offer helper (31 Oct 2026, 01-website/projects/2026-10-31-apply-offer-and-product-pages/).

  1. Ad visitors: a visit that arrives with ?cp_offer=summer20 (the final-URL suffix google-ads adds to Shopping) or a
     Google Ads gclid is remembered for the visit, and <html> gets the class cp-offer-summer20. The product page's
     SUMMER20 line (snippets/cp-summer20-offer.liquid) shows only with that class, or when the code is already saved.
     The snippet sets the class itself inline as well, so the line doesn't jump in late.
  2. "Apply my 20%": any [data-cp-apply-code] button saves the code with Shopify's discount link (/discount/CODE), so
     it's already applied at checkout. Then <html> gets cp-code-<code> and the cart drawer redraws.
     window.cpApplyCode(code) does the same for other scripts (assets/cp-landing-cart.js applies the page's code before
     adding, so the drawer shows it).
*/
(() => {
  if (window.cpOffer) return;
  window.cpOffer = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const html = document.documentElement;

  try {
    if (/[?&](cp_offer=summer20|gclid=)/i.test(window.location.search)) sessionStorage.setItem('cpOffer', 'summer20');
    if (sessionStorage.getItem('cpOffer') === 'summer20') html.classList.add('cp-offer-summer20');
    // A code saved earlier in the visit (Shopify keeps it on the cart) still shows as saved on later pages.
    Object.keys(sessionStorage).forEach((key) => {
      if (key.indexOf('cpCode_') === 0) html.classList.add('cp-code-' + key.slice(7).toLowerCase());
    });
  } catch (error) { /* private mode: the line simply stays hidden */ }

  const applied = new Set();

  window.cpApplyCode = async (code) => {
    code = String(code || '').trim().toUpperCase();
    if (!code) return false;
    if (applied.has(code)) return true;
    // Redirect to the small cart JSON rather than a page, so the code is saved without loading one.
    const response = await fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), {
      credentials: 'same-origin'
    });
    if (!response.ok) return false;
    applied.add(code);
    html.classList.add('cp-code-' + code.toLowerCase());
    try { sessionStorage.setItem('cpCode_' + code, '1'); } catch (error) { /* private mode */ }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return true;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cp-apply-code]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    const code = button.getAttribute('data-cp-apply-code');
    const status = document.getElementById(button.getAttribute('aria-controls') || '');
    button.setAttribute('aria-busy', 'true');
    let ok = false;
    try { ok = await window.cpApplyCode(code); } catch (error) { ok = false; }
    button.removeAttribute('aria-busy');
    if (status) {
      status.textContent = ok
        ? code + ' is saved. Your 20% comes off at checkout.'
        : 'Sorry, that didn’t work. Please type ' + code + ' at checkout.';
    }
    if (ok) button.classList.add('is-applied');
  });
})();
